export const GET_SCANNER_DATA = "GET_SCANNER_DATA";
export const SET_SCANNER_DATA = "SET_SCANNER_DATA";
export const REMOVE_SCANNER_DATA = "REMOVE_SCANNER_DATA";
export const SET_WEBCAM_CRASHED = "SET_WEBCAM_CRASHED";
export const SET_TEST_IDS = "SET_TEST_IDS";
export const SET_CURRENT_DOCUMENT = "SET_CURRENT_DOCUMENT";
